/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import { ModalProgressBar } from "../../../_themeBase/_partials/controls";
import * as auth from "../Auth";
import * as actions from "../../../app/actions/generalActions";
import * as columnFormatters from "../../../_themeBase/layout/components/basePage/pages/objects-table/column-formatters";



function ShowRankingTable({ mode = "MyScore", userId }) {
  // Fields
  const [loading, setloading] = useState(false);
  const dispatch = useDispatch();

  const { otherUserState } = useSelector(
    (state) => ({ otherUserState: state.baseInfo.users }),
    shallowEqual
  );

  var user = useSelector((state) => state.auth.user, shallowEqual);
  if (mode === "OtherScore")
    user = otherUserState.objectForEdit;

  const rankingSettings = useSelector((state) => state.baseInfo.rankingSettings, shallowEqual);
  useEffect(() => { }, [user]);
  // Methods
  const history = useHistory()
  

  useEffect(() => {
    if (mode === "MyScore")
      dispatch(actions.fetchAllObjects("api/RankingSetting", rankingSettings.name, "GetUserRanking"))
    else {
      dispatch(actions.fetchObject("api/RankingSetting", rankingSettings.name, userId, "GetUserRankingById"));
    }

  }, []);

  const columns = [
    {
      dataField: "rpType",
      text: "نوع",
      formatter: columnFormatters.RankingParameterColumnFormatter,
    },
    {
      dataField: "title",
      text: "عنوان",
    },
    {
      dataField: "rankValue",
      text: "امتیاز ",
    },

  ];

  return (
    <div className="card card-custom">
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            امتیازات من
          </h3>
          <span className="text-muted font-weight-bold font-size-sm mt-1">
            مجموع امتیازات من : {user.score}
          </span>
        </div>

      </div>
      {/* end::Header */}
      <div className="card-body">
        {mode === "MyScore" && rankingSettings && rankingSettings.entities && rankingSettings.entities.length > 0 &&
          <BootstrapTable
            wrapperClasses="table-responsive"
            rowStyle={{ fontSize: 12 }}
            // rowStyle={rowStyle}
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bordered={false}
            bootstrap4
            remote
            keyField="id"
            data={rankingSettings.entities === null ? [] : rankingSettings.entities}
            columns={columns}

          >
          </BootstrapTable>
        }

        {mode === "OtherScore" && rankingSettings && rankingSettings.objectForEdit && rankingSettings.objectForEdit.length > 0 &&
          <BootstrapTable
            wrapperClasses="table-responsive"
            rowStyle={{ fontSize: 12 }}
            // rowStyle={rowStyle}
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bordered={false}
            bootstrap4
            remote
            keyField="id"
            data={rankingSettings.objectForEdit === null ? [] : rankingSettings.objectForEdit}
            columns={columns}

          >
          </BootstrapTable>
        }
      </div>
    </div>
  );
}

export default connect(null, auth.actions)(ShowRankingTable);
